import React, { useEffect, useRef, useState } from 'react';
import { api } from '../../../../../api';

type StoryLookupResponse = {
  success: boolean
  story: { chapter: number | null; title: string } | null
};

/**
 * When `uuid` is exactly 36 characters, looks up Stories (groupId=1, language=0) and shows `Ep {chapter}: {title}`.
 */
export function EpisodeUuidLookupHint(props: { uuid: string }) {
  const trimmed = String(props.uuid ?? '').trim();
  const [line, setLine] = useState<string | null>(null);
  const seqRef = useRef(0);

  useEffect(() => {
    if (trimmed.length !== 36) {
      setLine(null);
      return;
    }
    const seq = ++seqRef.current;
    const handle = window.setTimeout(() => {
      api
        .get<StoryLookupResponse>(`/v1/stories/by-episode-uuid/${encodeURIComponent(trimmed)}`)
        .then((res) => {
          if (seqRef.current !== seq) return;
          const s = res.data?.story;
          if (!s) {
            setLine(null);
            return;
          }
          const ch = s.chapter != null ? String(s.chapter) : '?';
          setLine(`[Ep ${ch}] ${s.title ?? ''}`);
        })
        .catch(() => {
          if (seqRef.current !== seq) return;
          setLine(null);
        });
    }, 300);
    return () => window.clearTimeout(handle);
  }, [trimmed]);

  if (!line) return null;
  return <div className="small mt-1 text-primary">{line}</div>;
}
